import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Card, Grid, InputLabel, Stack, Typography } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import KitchenIcon from '@mui/icons-material/Kitchen';
import WifiIcon from '@mui/icons-material/Wifi';
import TvIcon from '@mui/icons-material/Tv';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HotTubIcon from '@mui/icons-material/HotTub';
import KitesurfingIcon from '@mui/icons-material/Kitesurfing';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import React from 'react';
import { Liquor, Restaurant } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';
import FormCounter from '../../../../shared/FormCounter';

export default function NewBoatAmenitiesForm() {
    const theme = useTheme();
    const { control, setValue } = useFormContext();

    const items = [
        {
            name: 'catering',
            selected: false,
            icon: <Restaurant fontSize='large' />,
        },
        {
            name: 'alcohol',
            selected: false,
            icon: <Liquor fontSize='large' />,
        },
        {
            name: 'boardroom',
            selected: false,
            icon: <BusinessCenterIcon fontSize='large' />,
        },
        {
            name: 'kitchen',
            selected: false,
            icon: <KitchenIcon fontSize='large' />,
        },
        {
            name: 'wifi',
            selected: false,
            icon: <WifiIcon fontSize='large' />,
        },
        {
            name: 'tv',
            selected: false,
            icon: <TvIcon fontSize='large' />,
        },
        {
            name: 'aircon',
            selected: false,
            icon: <AcUnitIcon fontSize='large' />,
        },
        {
            name: 'spa',
            selected: false,
            icon: <HotTubIcon fontSize='large' />,
        },
        {
            name: 'waterSports',
            selected: false,
            icon: <KitesurfingIcon fontSize='large' />,
        },
        {
            name: 'bbq',
            selected: false,
            icon: <OutdoorGrillIcon fontSize='large' />,
        },
    ];

    return (
        <fieldset>
            <Stack spacing={2}>
                <div>
                    <Typography variant='h2' component='legend'>
                        Experience Amenities
                    </Typography>
                    <Typography color='text.secondary' gutterBottom>
                        Tell guests what your boat has to offer
                    </Typography>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='bedrooms__input'>
                        No. Bedrooms
                    </InputLabel>
                    <FormCounter
                        id='bedrooms__input'
                        name='details.bedrooms'
                        max={20}
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='beds__input'>No. Beds</InputLabel>
                    <FormCounter
                        id='beds__input'
                        name='details.beds'
                        max={20}
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='baths__input'>
                        No. Bathrooms
                    </InputLabel>
                    <FormCounter
                        id='baths__input'
                        name='details.baths'
                        max={20}
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='max-guests__input'>
                        No. Day Guests
                    </InputLabel>
                    <FormCounter
                        id='max-guests__input'
                        name='details.maxGuests'
                        max={70}
                        disabled={false}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='overnight-guests__input'>
                        No. Overnight Guests
                    </InputLabel>
                    <FormCounter
                        id='overnight-guests__input'
                        name='details.overnightGuests'
                        max={70}
                        disabled={false}
                    />
                </Box>
            </Stack>
            <Typography
                color='textPrimary'
                pb='20px'
                pt='30px'
                id='experience-amenities-select'
            >
                Select available amenities:
            </Typography>
            <Grid
                container
                columns={{ lg: 5, md: 4, xs: 2 }}
                spacing={2}
                aria-labelledby='experience-amenities-select'
            >
                {items.map((item, i) => (
                    <Grid item xs={1} key={i}>
                        <Controller
                            name={`details.${item.name}`}
                            control={control}
                            render={({ field: { value } }) => (
                                <Card
                                    sx={{
                                        height: '100px',
                                        bgcolor: value
                                            ? theme.palette.primary.main
                                            : theme.palette.neutral.main,
                                        color: value
                                            ? theme.palette.primary.contrastText
                                            : theme.palette.text.primary,
                                    }}
                                    onClick={() =>
                                        setValue(
                                            `details.${item.name}`,
                                            !value,
                                            { shouldDirty: true },
                                        )
                                    }
                                >
                                    <Box
                                        display='flex'
                                        flexDirection='column'
                                        alignItems='center'
                                        height='100%'
                                        gap={1}
                                        justifyContent='center'
                                        textAlign='center'
                                    >
                                        {item.icon}
                                        <Typography
                                            sx={{
                                                color: value
                                                    ? theme.palette.primary
                                                          .contrastText
                                                    : theme.palette.text
                                                          .primary,
                                            }}
                                        >
                                            {item.name === 'bbq'
                                                ? 'BBQ'
                                                : item.name === 'tv'
                                                  ? 'TV'
                                                  : item.name === 'waterSports'
                                                    ? 'Water Sports'
                                                    : item.name
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                      item.name.slice(1)}
                                        </Typography>
                                    </Box>
                                </Card>
                            )}
                        />
                    </Grid>
                ))}
            </Grid>
        </fieldset>
    );
}
